import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import family from "assets/svg/Bluepassport.svg";
import passport from "assets/svg/blueMyFamily.svg";
import HomeInsurance from "assets/svg/HomeInsurance.svg";
import rightArrow from "assets/svg/right-arw1.svg";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const ProductAndServicesCard = ({
  motorOtherProductsData,
  title,
  dontShowSlider,
  headerMobileClass,
  isSpace = false,
}) => {
  const { i18n, t } = useTranslation();

  const otherProductData = [
    {
      id: 1,
      icon: passport,
      otherProductTitle: t("productAndServices.internationTravel"),
      otherProductPara: t("productAndServices.internationTravelDesc"),
      otherProductSubTitle: t("productAndServices.benefits"),
      otherProductSubParaOne: t("productAndServices.medicalEmergency"),
      otherProductSubParaTwo: t("productAndServices.freeCoverage"),
      link: "/individuals/products/property-casualty/international-travel",
    },
    {
      id: 2,
      icon: family,
      otherProductTitle: t("productAndServices.myFamily"),
      otherProductPara: t("productAndServices.myFamilyDesc"),
      otherProductSubTitle: t("productAndServices.benefits"),
      otherProductSubParaOne: t("productAndServices.medicalEmergency"),
      otherProductSubParaTwo: t("productAndServices.freeCoverage"),
      link: "/individuals/products/health/my-family-insurance",
    },
    {
      id: 3,
      icon: HomeInsurance,
      otherProductTitle: t("productAndServices.homeInsurance"),
      otherProductPara: t("productAndServices.homeInsuranceDesc"),
      otherProductSubTitle: t("productAndServices.benefits"),
      otherProductSubParaOne: t("productAndServices.medicalEmergency"),
      otherProductSubParaTwo: t("productAndServices.freeCoverage"),
      link: "/individuals/products/property-casualty/home-insurance",
    },
  ];

  const trackEvent = (tabClicked) => {
    window.lmSMTObj.track(tabClicked);
  }

  return (
    <div className={`${isSpace} product-service-card-container`}>
      <div className={`product-service-header ${headerMobileClass}`}>
        <h5 className="header-heading">{t("productAndServices.title")}</h5>
        <p className="header-sub-heading">{t("productAndServices.desc")}</p>
      </div>
      <div className="product-service-outer-wrapper">
        <div className="product-service-inner-wrapper">
          {otherProductData.map((item, index) => {
            return (
              <div className="service-product-card" key={index}>
                <div className="card-wrap">
                  <div className="inner-card-wrapper">
                    <div className="upper-part">
                      <img src={item.icon} className="img-fluid" alt="icon" />
                      <p className="card-heading">{item.otherProductTitle}</p>
                      <p className="card-sub-title">{item.otherProductPara}</p>
                    </div>

                    <div className="lower-part">
                      <p className="lover-sub-header">{item.otherProductSubTitle}</p>
                      <ul className="benefit-list">
                        <li className="benefit-item">{item.otherProductSubParaOne}</li>
                        <li className="benefit-item">{item.otherProductSubParaTwo}</li>
                      </ul>
                    </div>
                  </div>
                  {window.innerWidth > 950 && (
                    <>
                      <hr />
                      <Link to={item.link} onClick={() => {trackEvent(item.otherProductTitle+"LearnMoreClicked")}}>
                        <div className="benefit-card-footer">
                          <p className="learn-more-text">{t("productAndServices.learnMore")}</p>
                          <img alt="Tawanya" src={rightArrow} />
                        </div>
                      </Link>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {
        window.innerWidth > 950 &&
        <div className="view-all">
          <div className="view-all-questions">
            <Link to={"/individuals/products/all-products"} className="view-all-text" onClick={() => {trackEvent(t('productAndServices.viewAll')+"Clicked")}}>
              {t('productAndServices.viewAll')}
              <img className="view-all-image mx-2 cursor-pointer" src={rightArrow} alt="view all" />
            </Link>
          </div>
        </div>
      }
    </div>
  );
};
